import { render, staticRenderFns } from "./NautaFaqDetail.vue?vue&type=template&id=9af31c00&scoped=true"
import script from "./NautaFaqDetail.vue?vue&type=script&lang=js"
export * from "./NautaFaqDetail.vue?vue&type=script&lang=js"
import style0 from "./NautaFaqDetail.vue?vue&type=style&index=0&id=9af31c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af31c00",
  null
  
)

export default component.exports